import { render, staticRenderFns } from "./g-tooltip.vue?vue&type=template&id=2f2238cc&scoped=true&"
import script from "./g-tooltip.vue?vue&type=script&lang=js&"
export * from "./g-tooltip.vue?vue&type=script&lang=js&"
import style0 from "./g-tooltip.vue?vue&type=style&index=0&id=2f2238cc&lang=scss&scoped=true&"
import style1 from "./g-tooltip.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2238cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
